'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-cd939937.js');
var FingerprintJS = require('@fingerprintjs/fingerprintjs');
var device = require('./device.js');
var localStore = require('./localStore.js');
var cookie = require('./cookie.js');
var makeHash = require('./makeHash.js');
require('ua-parser-js');
require('./memoryStorage.js');
require('./_storageService-4a3804f6.js');
require('./makeId.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var FingerprintJS__default = /*#__PURE__*/_interopDefaultLegacy(FingerprintJS);

function visitorIdTest() {
    return tslib_es6.__awaiter(this, void 0, void 0, function () {
        var lastOrigUdid, lastUdid, fpPromise, fp, result, newUdid;
        return tslib_es6.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lastOrigUdid = localStore.localStore.get('fp_orig_udid') || cookie.cookieSrv.get('fp_orig_udid');
                    lastUdid = localStore.localStore.get('fp_udid') || cookie.cookieSrv.get('fp_udid');
                    fpPromise = FingerprintJS__default['default'].load({
                        // @ts-ignore
                        monitoring: false,
                    });
                    return [4 /*yield*/, fpPromise];
                case 1:
                    fp = _a.sent();
                    return [4 /*yield*/, fp.get()];
                case 2:
                    result = _a.sent();
                    newUdid = result.visitorId;
                    if (device.device.isIOS()) {
                        if (lastOrigUdid === newUdid) {
                            newUdid = lastUdid;
                            // @ts-ignore
                            result.iosVisitorId = newUdid;
                        }
                        else {
                            newUdid = newUdid.slice(0, newUdid.length - 6) + makeHash.makeHash(6);
                            // @ts-ignore
                            result.iosVisitorId = newUdid;
                        }
                    }
                    localStore.localStore.set('fp_udid', newUdid);
                    localStore.localStore.set('fp_orig_udid', result.visitorId);
                    cookie.cookieSrv.set('fp_udid', newUdid, { 'Max-Age': 3600 * 24 * 365 * 10 });
                    cookie.cookieSrv.set('fp_orig_udid', result.visitorId, { 'Max-Age': 3600 * 24 * 365 * 10 });
                    return [2 /*return*/, result];
            }
        });
    });
}

exports.visitorIdTest = visitorIdTest;
